/**
 * AssetFilename Component
 * Displays asset filename with truncation and tooltip
 */

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface AssetFilenameProps {
  fileName: string;
  className?: string;
  maxWidth?: string;
}

export function AssetFilename({
  fileName,
  className = "",
  maxWidth = "max-w-full",
}: AssetFilenameProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={`block ${maxWidth} truncate cursor-default ${className}`}
          >
            {fileName}
          </span>
        </TooltipTrigger>
        <TooltipContent className="bg-popover text-popover-foreground border">
          <p>{fileName}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
